import { makeAutoObservable } from "mobx";

const DEFAULT_PAGE_SIZE = 20;
const DEFAULT_SORT = { key: "disclosureCode", direction: "asc" };

// Filters live in dataEntryFiltersStore. This store owns result set,
// pagination, sort, plus drill-down breakdown cache.
class ConsolidatedStore {
  items = [];
  loading = false;
  page = 1;
  pageSize = DEFAULT_PAGE_SIZE;
  sort = DEFAULT_SORT;
  expandedRows = new Set();
  breakdownById = new Map(); // disclosureId → { items, note?, loading, error? }

  constructor() {
    makeAutoObservable(this);
  }

  setPage = (page) => {
    this.page = page;
  };

  setPageSize = (size) => {
    this.pageSize = size;
    this.page = 1;
  };

  setSort = (sort) => {
    this.sort = { ...this.sort, ...sort };
    this.page = 1;
  };

  setItems = (items) => {
    this.items = items;
  };

  toggleExpanded = (disclosureId) => {
    if (this.expandedRows.has(disclosureId)) {
      this.expandedRows.delete(disclosureId);
    } else {
      this.expandedRows.add(disclosureId);
    }
    this.expandedRows = new Set(this.expandedRows);
  };

  setBreakdown = (disclosureId, value) => {
    this.breakdownById.set(disclosureId, value);
    this.breakdownById = new Map(this.breakdownById);
  };

  clearBreakdownCache = () => {
    this.breakdownById = new Map();
    this.expandedRows = new Set();
  };

  setLoading = (v) => {
    this.loading = v;
  };

  reset = () => {
    this.items = [];
    this.loading = false;
    this.page = 1;
    this.pageSize = DEFAULT_PAGE_SIZE;
    this.sort = DEFAULT_SORT;
    this.expandedRows = new Set();
    this.breakdownById = new Map();
  };
}

export const consolidatedStore = new ConsolidatedStore();
